import { SelectOption } from '@/interfaces/select-option.interface'

export const isSelectOption = (object: any): object is SelectOption => object
    && object.value
    && typeof object.caption === 'string'
